/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _region = _interopRequireDefault(require("../region"));
var _alignToNormalized = _interopRequireDefault(require("./alignToNormalized"));
function COMPUTE_ALIGN_REGION(sourceRegion, targetRegion, positions, config) {
  sourceRegion = _region.default.from(sourceRegion);
  var sourceClone = sourceRegion.clone();
  var position = (0, _alignToNormalized.default)(sourceClone, targetRegion, positions, config);
  return {
    position: position,
    region: sourceClone,
    widthChanged: sourceClone.getWidth() != sourceRegion.getWidth(),
    heightChanged: sourceClone.getHeight() != sourceRegion.getHeight(),
    positionChanged: sourceClone.equalsPosition(sourceRegion)
  };
}
var _default = COMPUTE_ALIGN_REGION;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/region-align/computeAlignRegion.js
// module id = 769
// module chunks = 0